(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[673],{

/***/ 2695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppFooter */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);



var AppFooter = function() {
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "footer_container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "footer_about",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "about_us",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "about_logo",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                src: "/images/boom_logo.png",
                                alt: "Boom logo",
                                layout: "fill",
                                objectFit: "contain"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "about_info",
                            children: "Copyright \xa9 2021, BoomTV"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "about_links",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/terms",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Terms and Conditions"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/privacy",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Privacy"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/about",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "About"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            href: "/personal-data",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "about_link",
                                children: "Do Not Sell My Personal Information"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppFooter);


/***/ }),

/***/ 9735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AppHeader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5617);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1163);
/* harmony import */ var contexts_app_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6777);
/* harmony import */ var contexts_viewport__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(369);
/* harmony import */ var redux_global_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3663);
/* harmony import */ var redux_event_lobby_slice__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(8279);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3135);












function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
var AppHeader = function(param) {
    var _transparent = param.transparent, transparent = _transparent === void 0 ? false : _transparent;
    var asPath = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)().asPath;
    var ref = (0,contexts_viewport__WEBPACK_IMPORTED_MODULE_8__/* .useViewport */ .Sj)(), isTwoColumnView = ref.isTwoColumnView, width = ref.width;
    var ref1 = _slicedToArray((0,contexts_app_context__WEBPACK_IMPORTED_MODULE_7__/* .useAppContext */ .b)(), 2), state = ref1[0], configDispatch = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isScrolling = ref2[0], setIsScrolling = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowingHamburger = ref3[0], setIsShowingHamburger = ref3[1];
    var currentScreen = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_global_slice__WEBPACK_IMPORTED_MODULE_9__/* .selectors.currentScreen */ .wl.currentScreen);
    var eventTitle = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(redux_event_lobby_slice__WEBPACK_IMPORTED_MODULE_10__/* .selectors.eventTitle */ .wl.eventTitle);
    var goToHomePage = function() {
        window.location.href = '/';
    };
    var confirmGoToHomePage = function() {
        if (currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.EventLobby */ .wc.EventLobby || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay) {
            configDispatch({
                type: 'SET_CONFIRM_MESSAGE',
                payload: 'Are you sure you want to return to the home page?'
            });
            configDispatch({
                type: 'SHOW_MODAL_CONFIRM',
                payload: true
            });
            configDispatch({
                type: 'SET_CONFIRM_ACTION',
                payload: goToHomePage
            });
        }
    };
    var showModalJoinOuting = function() {
        configDispatch({
            type: 'SHOW_MODAL_JOIN_OUTING',
            payload: true
        });
    };
    var isEventTitleVisible = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return currentScreen && currentScreen !== utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.Landing */ .wc.Landing && (isTwoColumnView || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay);
    }, [
        isTwoColumnView,
        currentScreen
    ]);
    var toggleNavHamburger = function() {
        setIsShowingHamburger(!isShowingHamburger);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleScroll = function(e) {
            var offset = window.pageYOffset || document.documentElement.scrollTop;
            if (offset > 0) {
                setIsScrolling(true);
            } else {
                setIsScrolling(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return function() {
            return window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    var isWhiteNavbar = !transparent || isScrolling || isShowingHamburger;
    var isSmallLogoNeeded = (eventTitle === null || eventTitle === void 0 ? void 0 : eventTitle.length) > 20 && width < 650 && currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: 'nav_header' + (isWhiteNavbar ? ' white' : ''),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "container nav_header_inner",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "block_left",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_5___default()('header_logo', {
                                    small: isSmallLogoNeeded
                                }),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                    passHref: true,
                                    href: currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.EventLobby */ .wc.EventLobby || currentScreen === utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .AppScreens.GamePlay */ .wc.GamePlay ? 'javascript:void(0)' : '/',
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                        src: isSmallLogoNeeded ? '/images/modal_logo.png' : isWhiteNavbar ? '/images/header/logo_white.png' : '/images/header/logo.png',
                                        alt: "Logo",
                                        layout: "fill",
                                        objectFit: "contain",
                                        onClick: confirmGoToHomePage
                                    })
                                })
                            }),
                            isEventTitleVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "nav_logo_text",
                                children: isSmallLogoNeeded ? "".concat(eventTitle.slice(0, 16), "...") : eventTitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "block_right",
                        children: width > 650 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "nav_menu_container",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/help-details",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: "Help & Details"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                                        href: "/contact-us",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            children: "Contact"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "nav_menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "nav_button",
                                        onClick: showModalJoinOuting,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: "Create Now"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "arrow_button"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "nav_menu_container",
                            children: isWhiteNavbar ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                src: "/images/header/hamburger_grey.png",
                                alt: "Hamburger",
                                width: 27,
                                height: 23,
                                onClick: toggleNavHamburger
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                src: "/images/header/hamburger.png",
                                alt: "Hamburger",
                                width: 27,
                                height: 23,
                                onClick: toggleNavHamburger
                            })
                        })
                    })
                ]
            }),
            width <= 650 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: 'nav_mobile_menu' + (isShowingHamburger ? ' show' : ''),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_shadow"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            href: "/help-details",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Help & Details"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            href: "/contact-us",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: "Contact"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "nav_mobile_button",
                        onClick: showModalJoinOuting,
                        children: "Create Now"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppHeader);


/***/ }),

/***/ 6413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IconClose */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var IconClose = function(param) {
    var _color = param.color, color = _color === void 0 ? '#2050C4' : _color;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "17",
        height: "17",
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "11.2031",
                y: "5.24512",
                width: "1.08359",
                height: "8.12695",
                transform: "rotate(45 11.2031 5.24512)",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "1.08359",
                height: "8.12695",
                transform: "matrix(-0.707107 0.707107 0.707107 0.707107 6.01562 5.24609)",
                fill: color
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "8.49032",
                cy: "8.49032",
                r: "7.03118",
                stroke: color,
                strokeWidth: "1.08172"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (IconClose);


/***/ }),

/***/ 8049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ModalJoinOuting; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var contexts_app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6777);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1955);
/* harmony import */ var _icon_close__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6413);
/* harmony import */ var styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6280);
/* harmony import */ var styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6__);







function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function ModalJoinOuting() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''), displayName = ref[0], setDisplayName = ref[1];
    var ref1 = _slicedToArray((0,contexts_app_context__WEBPACK_IMPORTED_MODULE_3__/* .useAppContext */ .b)(), 2), state = ref1[0], dispatch = ref1[1];
    var showModalJoinOuting = state.showModalJoinOuting, passcodeModalJoinOuting = state.passcodeModalJoinOuting;
    var closeModalJoinOuting = function() {
        dispatch({
            type: 'SHOW_MODAL_JOIN_OUTING',
            payload: false
        });
    };
    var handleKeyDown = function(event) {
        if (event.key === 'Enter') {
            submit();
        }
    };
    var submit = function() {
        var inSixtyMinutes = new Date(new Date().getTime() + 60 * 60 * 1000);
        js_cookie__WEBPACK_IMPORTED_MODULE_4__/* ["default"].set */ .Z.set('displayName', displayName === null || displayName === void 0 ? void 0 : displayName.trim(), {
            expires: inSixtyMinutes
        });
        if ((displayName === null || displayName === void 0 ? void 0 : displayName.trim()) && passcodeModalJoinOuting) {
            window.location.href = "/events/".concat(passcodeModalJoinOuting);
        } else {
            closeModalJoinOuting();
            if ((displayName === null || displayName === void 0 ? void 0 : displayName.trim()) && window.location.pathname !== '/landing') {
                window.location.href = '/landing';
            }
        }
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_message) + (showModalJoinOuting ? '' : ' hide'),
        id: "modal_join_outing",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_logo),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                src: "/images/modal_logo.png",
                                alt: "Team Games Logo",
                                width: 88,
                                height: 48
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_title),
                            children: "Join Outing"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_close),
                            onClick: closeModalJoinOuting,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_close__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_body),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().message_content),
                            style: {
                                display: 'block'
                            },
                            children: [
                                "Enter Your Name",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    type: "text",
                                    className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().join_outing_input),
                                    placeholder: "Begin typing here",
                                    onChange: function(e) {
                                        return setDisplayName(e.target.value);
                                    },
                                    onKeyDown: handleKeyDown
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_actions),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_6___default().modal_footer_btn),
                                onClick: submit,
                                children: "Submit"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};


/***/ }),

/***/ 3913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ModalMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var contexts_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6777);
/* harmony import */ var _icon_close__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6413);
/* harmony import */ var styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6280);
/* harmony import */ var styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4__);





function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function ModalMessage() {
    var ref = _slicedToArray((0,contexts_app_context__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .b)(), 2), state = ref[0], dispatch = ref[1];
    var showModalMsg = state.showModalMsg, messageAlert = state.messageAlert;
    var closeModalMessage = function() {
        dispatch({
            type: 'SHOW_MODAL_MESSAGE',
            payload: false
        });
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().modal_message) + (showModalMsg ? '' : ' hide'),
        id: "modal_message",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().modal_container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().modal_header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().modal_logo),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                src: "/images/modal_logo.png",
                                alt: "Team Games Logo",
                                width: 88,
                                height: 48
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().modal_title),
                            children: messageAlert.additional ? messageAlert.additional.messageTitle : ''
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().modal_close),
                            onClick: closeModalMessage,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_close__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().modal_body),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().message_content),
                            children: messageAlert.additional ? messageAlert.additional.message : messageAlert
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().modal_actions),
                            children: [
                                messageAlert.additional && messageAlert.additional.action && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().modal_footer_btn),
                                    onClick: function() {
                                        messageAlert.additional.action();
                                        closeModalMessage();
                                    },
                                    children: messageAlert.additional.btnText
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (styles_modal_confirm_module_css__WEBPACK_IMPORTED_MODULE_4___default().modal_footer_btn),
                                    onClick: closeModalMessage,
                                    children: messageAlert.additional ? messageAlert.additional.btnClose : 'Close'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};


/***/ }),

/***/ 6280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal_message":"modal_confirm_modal_message__iAMav","modal_container":"modal_confirm_modal_container__fW6ri","modal_header":"modal_confirm_modal_header__mRRXp","modal_logo":"modal_confirm_modal_logo__265lr","modal_title":"modal_confirm_modal_title__rgc0P","modal_close":"modal_confirm_modal_close__DzFM0","modal_body":"modal_confirm_modal_body__ZBCOc","message_content":"modal_confirm_message_content___bxgK","modal_actions":"modal_confirm_modal_actions__h17bb","join_outing_input":"modal_confirm_join_outing_input__tC0SX","feedback_error":"modal_confirm_feedback_error__J0_rb","modal_footer":"modal_confirm_modal_footer__HqmU5","confirm":"modal_confirm_confirm__Pv_Ug","modal_footer_btn":"modal_confirm_modal_footer_btn__cS1lI"};

/***/ })

}]);